import React, { FC, useEffect, useRef, useState, useContext, useCallback } from "react";
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import { get, post } from "../fetchers/fetchers";
import {
    IAssessmentSettings,
    IAssessmentProject,
} from "../types/types";

import {
    MenuItem,
    Paper,
    Select,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow, TextField
} from "@material-ui/core";
import { useParams } from "react-router";

import { API_URL, APPLICATION } from "../env";
import { FormattedInput } from '@h-a-r-c/react-formatted-input';
import { getAssessmentSettings, getControlMeasureCosts } from "../stateManagement/data";
import { set } from "date-fns";

interface IAssessmentSettingsProps {
    // updateAssessmentSettings: (currentSettings: IAssessmentSettings) => void;

}

interface IRouteParams {
    id: string
}



const AssessmentSettings: FC<IAssessmentSettingsProps> = () => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()


    const [write_access, setWriteAccess] = useState<boolean>(true);

    const params = useParams<IRouteParams>()


    const [currentAssessmentSettings, setCurrentAssessmentSettings] = useState<IAssessmentSettings>();


    const handleUpdateCustomSettings = (assessmentSettings: IAssessmentSettings) => {

        if (assessmentSettings) {
            pushAssessmentSettings(assessmentSettings).then(() => {
                getAssessmentSettings(params.id, dispatch)
                getControlMeasureCosts(params.id, dispatch)
                // reload web page
                window.location.reload()
            }
            )
        }
    }

    const pushAssessmentSettings = async (assessmentSettings: IAssessmentSettings) => {
        let c = { ...assessmentSettings }
        delete c.id

        await post<IAssessmentSettings>(API_URL + "assessment_project/" + params.id.toString() + "/settings", c);

    }

    useEffect(() => {
        if (tasks.loaded) {
            setCurrentAssessmentSettings(tasks.assessmentSettings)
        }
    }, [tasks.loaded, tasks.assessmentSettings])


    return (
        <>
            <Paper variant={"outlined"} style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>Assessment Type</TableCell>
                            <TableCell>
                                {currentAssessmentSettings && <Select
                                    style={{ fontSize: "11pt" }}
                                    value={currentAssessmentSettings?.type}
                                    disabled={!write_access}
                                    onChange={(event) => {
                                        let value = event.target.value as string
                                        if (value) {
                                            let c = { ...currentAssessmentSettings }
                                            c.type = value
                                            setCurrentAssessmentSettings(c)
                                            handleUpdateCustomSettings(c)
                                        }
                                    }}>
                                    <MenuItem value={"SFAIRP"}>SFAIRP</MenuItem>
                                    <MenuItem value={"ALARP"}>ALARP</MenuItem>

                                </Select>
                                }
                            </TableCell>
                        </TableRow>
                        { APPLICATION !== "ALARP" &&
                        <TableRow>
                            <TableCell>Consider Societal Concerns</TableCell>
                            <TableCell>
                                {currentAssessmentSettings && (
                                    <Switch
                                        checked={currentAssessmentSettings.consider_societal_concerns ?? false}
                                        disabled={!write_access}
                                        onChange={(event) => {
                                            const c = { ...currentAssessmentSettings };
                                            c.consider_societal_concerns = event.target.checked;
                                            setCurrentAssessmentSettings(c);
                                            handleUpdateCustomSettings(c);
                                        }}
                                    />
                                )}
                            </TableCell>
                        </TableRow>
                        }
                        <TableRow>
                            <TableCell>Control Measure Centric</TableCell>
                            <TableCell>
                                {currentAssessmentSettings && <Switch 
                                    checked={currentAssessmentSettings?.is_failure_mode_centric ?? false}
                                    disabled={!write_access}
                                    onChange={(event) => {
                                        let c = { ...currentAssessmentSettings }
                                        c.is_failure_mode_centric = event.target.checked ?? false
                                        setCurrentAssessmentSettings(c)
                                        handleUpdateCustomSettings(c)
                                    }} />
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>DF and CSSL assessment</TableCell>
                            <TableCell>
                                {currentAssessmentSettings && <Select
                                    style={{ fontSize: "11pt" }}
                                    value={currentAssessmentSettings?.ancold_guideline_id ?? 1}
                                    disabled={!write_access}
                                    onChange={(event) => {
                                        let value = parseInt(event.target.value as string)
                                        if (value) {
                                            let c = { ...currentAssessmentSettings }
                                            c.ancold_guideline_id = value
                                            setCurrentAssessmentSettings(c)
                                            handleUpdateCustomSettings(c)

                                        }
                                    }}>
                                    <MenuItem value={1}>ANCOLD 2003</MenuItem>
                                    <MenuItem value={2}>ANCOLD 2022</MenuItem>

                                </Select>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Societal Safety Threshold</TableCell>
                            <TableCell>
                            {currentAssessmentSettings && <FormattedInput
                                    obj={currentAssessmentSettings}
                                    fieldKey={"safety_threshold_societal"}
                                    format={"scientific"}
                                    setObj={setCurrentAssessmentSettings}
                                    updateObj={handleUpdateCustomSettings}
                                    write_access={write_access}
                                />}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Individual Safety Threshold</TableCell>
                            <TableCell>
                            {currentAssessmentSettings && <FormattedInput
                                    obj={currentAssessmentSettings}
                                    fieldKey={"safety_threshold_individual"}
                                    format={"scientific"}
                                    setObj={setCurrentAssessmentSettings}
                                    updateObj={handleUpdateCustomSettings}
                                    write_access={write_access}
                                />}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
        </>
    );
}

export default AssessmentSettings;
